"use strict"

var app = angular.module("app", [
	"ui.router", 
	// "ngAnimate", 
	'ui.tinymce',
	"ui.bootstrap",
	"ui.sortable", 
	"ngStorage",
	'oi.select',
	"dashboardModule",
	"loginModule",
	"servicesModule",
	"postsModule",
	// "blogsModule",
	// "newsServicesModule",
	"ratingsModule",
	"mediaModule",
	"pagesModule",
	"approvalsModule",
	"aiModule",
	"usersModule",
	"pollsModule",
	// "focusModule",
	"commentsModule",
	// "newstickerModule",
	"popularpostsModule",
	"macrositesModule",
	"menusModule",
	"notificationsModule",
	"logsModule",
	"videoModule",
	// "eSportsModule",
	"adsModule",
	// "blicModule",
	// "catalogsModule",
	// "wCupModule",
	// "covidRestrictionsModule"
		// "btford.socket-io",
	
]);

if(!enviroment.isDevelopment) {		
	console.log('Sentry is enabled in production');
	// ============================================================================
	// SENTRY ANGULAR INTEGRATION
	// ============================================================================
	// Set up Sentry's Angular $exceptionHandler integration
	// All logic is in sentryIntegration.js
	// ============================================================================
	var sentryIntegration = require('./sentryIntegration.js');
	sentryIntegration.setupAngular(app);
	// ============================================================================
}
require('./config.js')(app);
require('./utils.js')(app);
require('./appController.js')(app);
require('./appRouteConfig.js')(app);
require('./appConfig.js')(app);
require('./navigation/navigation.js')(app);
require('./navigation/navigationTemplate.js')(app);
require('./directive/ngEnterDirective.js')(app);
require('./directive/ngEscapeDirective.js')(app);
require('./directive/autoCompleteDirective.js')(app);
require('./directive/characterCountDirective.js')(app);
require('./directive/highligtedCharacterDirective.js')(app);
require('./directive/autoHeightDirective.js')(app);
require('./directive/convertToNumber.js')(app);
require('./directive/sortableDirective.js')(app);
require('./directive/searchAllPostSortable/searchAllPostSortableDirective.js')(app);
require('./directive/quickEditDirective.js')(app);
require('./directive/bulkDeleteDirective.js')(app);
require('./directive/deleteItemDirective.js')(app);
require('./filter/oiSelectFilters.js')(app);
require('./filter/arrayFilters.js')(app);
require('./filter/decimalsPercentageFilter.js')(app);
require('./directive/addPostToExchange/addPostToExchangeDirective.js')(app);
require('./directive/categoryAccordion/categoryAccordionDirective.js')(app);
require('./directive/checkedListItem/checkedListItemDirective.js')(app);
require('./directive/addApproval/addApprovalDirective.js')(app);
require('./directive/uploadPhotoMl/uploadPhotoMlDirective.js')(app);
require('./directive/searchPost/searchPostDirective.js')(app);
require('./directive/notificationCenter/notificationCenterDirective.js')(app);
require('./directive/tinymceBasic/tinymceBasicDirective.js')(app);
require('./directive/tinymceBasic/tinymceBasicController.js')(app);
require('./directive/searchPoll/searchPollDirective.js')(app);
require('./directive/searchRating/searchRatingDirective.js')(app);
require('./directive/searchBlogModal/searchBlogModalDirective.js')(app);
require('./directive/keywords/keywordsDIrective.js')(app);
require('./directive/AIModal/aiModalDirective.js')(app);
require('./directive/AIModal/aiRecomendationsDirective.js')(app);
require('./directive/AIModal/aiEditorDirective.js')(app);



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/app.js
// module id = 422
// module chunks = 0